var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-topbar-gran-cliente"},[_c('button',{staticClass:"p-link layout-menu-button",on:{"click":_vm.onMenuToggle}},[_c('span',{staticClass:"pi pi-bars"})]),_c('div',{staticClass:"layout-topbar-icons"})])}
var staticRenderFns = []

export { render, staticRenderFns }